/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface ContactRoleMapping
 */
export interface ContactRoleMapping {
    /**
     * 
     * @type {ParticipantRole}
     * @memberof ContactRoleMapping
     */
    oldRole?: ParticipantRole;
    /**
     * 
     * @type {ParticipantRole}
     * @memberof ContactRoleMapping
     */
    newRole?: ParticipantRole;
}

/**
 * Check if a given object implements the ContactRoleMapping interface.
 */
export function instanceOfContactRoleMapping(value: object): boolean {
    return true;
}

export function ContactRoleMappingFromJSON(json: any): ContactRoleMapping {
    return ContactRoleMappingFromJSONTyped(json, false);
}

export function ContactRoleMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactRoleMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'oldRole': json['oldRole'] == null ? undefined : ParticipantRoleFromJSON(json['oldRole']),
        'newRole': json['newRole'] == null ? undefined : ParticipantRoleFromJSON(json['newRole']),
    };
}

export function ContactRoleMappingToJSON(value?: ContactRoleMapping | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'oldRole': ParticipantRoleToJSON(value['oldRole']),
        'newRole': ParticipantRoleToJSON(value['newRole']),
    };
}

